import React from 'react';
import '../styles/modals.css';
import '../styles/modalMinimal.css';

/**
 * Componente Modal reutilizable para toda la aplicación
 * @param {Object} props
 * @param {boolean} props.isOpen - Si el modal está abierto
 * @param {function} props.onClose - Función para cerrar el modal
 * @param {string} props.title - Título del modal
 * @param {string} props.subtitle - Subtítulo opcional
 * @param {string} props.icon - Icono (emoji o clase de FontAwesome) - ej: "📝" o "fas fa-pencil"
 * @param {React.ReactNode} props.children - Contenido del modal
 * @param {string} props.size - Tamaño del modal: 's' | 'm' | 'l' | 'xl' (default: 'm')
 * @param {string} props.className - Clases CSS adicionales
 * @param {boolean} props.closeOnOverlayClick - Cerrar al hacer clic en el overlay (default: true)
 * @param {React.ReactNode} props.footer - Contenido del footer (botones, etc.)
 * @param {string} props.footerAlignment - Alineación del footer: 'end' | 'center' | 'between' (default: 'end')
 */
const Modal = ({
  isOpen,
  onClose,
  title,
  subtitle,
  icon,
  children,
  size = 'm',
  className = '',
  closeOnOverlayClick = true,
  footer,
  footerAlignment = 'end',
  minimal = false
}) => {
  if (!isOpen) return null;

  const handleOverlayClick = (e) => {
    if (closeOnOverlayClick && e.target === e.currentTarget) {
      onClose();
    }
  };

  const handleContentClick = (e) => {
    e.stopPropagation();
  };

  const sizeClass = `modal-${size}`;
  const footerClass = footerAlignment === 'center' ? 'modal-footer-center' :
                     footerAlignment === 'between' ? 'modal-footer-between' : '';

  return (
    <div className={`modal-overlay${minimal ? ' modal-minimal' : ''}`} onClick={handleOverlayClick}>
      <div className={`modal-content ${sizeClass} ${className}`} onClick={handleContentClick}>
        {/* Header */}
        <div className="modal-header">
          <div className="modal-header-content">
            {icon && <div className="modal-header-icon">{icon}</div>}
            <div className="modal-header-text">
              <h2 className="modal-header-title">{title}</h2>
              {subtitle && <p className="modal-header-subtitle">{subtitle}</p>}
            </div>
          </div>
          <button className="modal-close-btn" onClick={onClose} title="Cerrar">
            ✕
          </button>
        </div>

        {/* Body */}
        <div className="modal-body">
          {children}
        </div>

        {/* Footer */}
        {footer && (
          <div className={`modal-footer ${footerClass}`}>
            {footer}
          </div>
        )}
      </div>
    </div>
  );
};

export default Modal;
